import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59859b03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "character-info-edit" }
const _hoisted_2 = { class: "character-info-edit__name-section" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "character-info-edit__luck-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_IconButton, {
      type: "EditIcon",
      hint: _ctx.$t('edit'),
      variant: "transparent",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal = true))
    }, null, 8, ["hint"]),
    _createVNode(_component_ModalWindow, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modal) = $event)),
      title: _ctx.$t('edit-character-info')
    }, {
      default: _withCtx(() => [
        _createElementVNode("article", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                placeholder: _ctx.$t('character__name')
              }, null, 8, _hoisted_3), [
                [_vModelText, _ctx.name]
              ])
            ]),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.race) = $event)),
                placeholder: _ctx.$t('race')
              }, null, 8, _hoisted_4), [
                [_vModelText, _ctx.race]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("luck")) + ": ", 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.luck) = $event)),
                class: "",
                type: "number",
                inputmode: "number",
                min: 0,
                max: 4
              }, null, 512), [
                [_vModelText, _ctx.luck]
              ])
            ])
          ]),
          _createElementVNode("nav", null, [
            _createVNode(_component_Button, {
              title: _ctx.$t('ui-cancel'),
              secondary: "",
              onClick: _ctx.close
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("ui-cancel")), 1)
              ]),
              _: 1
            }, 8, ["title", "onClick"]),
            _createVNode(_component_Button, {
              title: _ctx.$t('ui-save'),
              disabled: !_ctx.isValidData,
              onClick: _ctx.save
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("ui-save")), 1)
              ]),
              _: 1
            }, 8, ["title", "disabled", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}